import React from 'react';

export default function Dashboard() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-indigo-700 mb-4">Admin Dashboard</h1>
      <p className="text-gray-700">
        Welcome to the central control panel for managing tenants, modules, and preferences.
      </p>
    </div>
  );
}
